import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CheckboxField from './CheckboxField';

import {
  fieldChange,
  registerField,
  unregisterField,
  getCheckboxChildren,
} from './actions';

function mapStateToProps(state) {
  return { checkboxes: state.checkboxes };
}

function mapDispatchToProps(dispatch) {
  return {
    getCheckboxChildren,
    ...bindActionCreators({
      fieldChange,
      registerField,
      unregisterField,
    }, dispatch),
  };
}

export default
/**
 * @deprecated This component is considered very legacy and should not be used.
 * It is recommended to avoid any further use of this component due to its outdated nature.
 * Consider using modern alternative instead such as CheckBoxArray. See Example in shared/components/Tables/Columns
 */
connect(
  mapStateToProps,
  mapDispatchToProps,
)(CheckboxField);
